var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedReportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:report"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.6654 7.58105L11.6654 2.58105H4.9987C4.55667 2.58105 4.13275 2.75665 3.82019 3.06921C3.50763 3.38177 3.33203 3.80569 3.33203 4.24772V17.5811C3.33203 18.0231 3.50763 18.447 3.82019 18.7596C4.13275 19.0721 4.55667 19.2477 4.9987 19.2477H14.9987C15.4407 19.2477 15.8646 19.0721 16.1772 18.7596C16.4898 18.447 16.6654 18.0231 16.6654 17.5811V7.58105ZM7.4987 16.7477H5.83203V9.24772H7.4987V16.7477ZM10.832 16.7477H9.16536V11.7477H10.832V16.7477ZM14.1654 16.7477H12.4987V14.2477H14.1654V16.7477ZM11.6654 8.41439H10.832V4.24772L14.9987 8.41439H11.6654Z",
    fill: "url(#paint0_linear_722_421)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_722_421",
    x1: 9.9987,
    y1: 2.58105,
    x2: 9.9987,
    y2: 19.2477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4056DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3746A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedReportIcon);
export default __webpack_public_path__ + "static/media/selectedReportIcon.2bc111a36fcdcfb09bb68dcf36ee8d3f.svg";
export { ForwardRef as ReactComponent };